import React, { useState, useEffect } from 'react';
import './LogosAndMessages.css';

const LogosAndMessages = ({  logos, messages } ) => {
    // const [logos, setLogos] = useState([]);
    // const [messages, setMessages] = useState([]);

    // useEffect(() => {
    //     fetch(`http://localhost:5000/logos_and_messages?commune=guingamp%20[22070]&adresse=7642`)
    //         .then(response => response.json())
    //         .then(data => {
    //             setLogos(data.logos);
    //             setMessages(data.messages);
    //         });
    // }, [commune]);

    return (
        <div className="logos-and-messages-container">
            <div className="logos-container">
                {logos.map((item, index) => (
                    <div key={index} className="logo-item">
                        <img
                            className="logo-image"
                            src={`data:${item.type};base64,${item.logo}`}
                            alt={item.logo_name}
                        />
                    </div>
                ))}
            </div>
            <div className="messages-container">
                {messages.map((item, index) => {
                    const messageTypeClass = item.type === "Bac ordures ménagères" ? "type-bac-ordures-menageres"
                                      : item.type === "Collecte sélective" ? "type-collecte-selective"
                                      : "type-autre";

                    return (
                        <div key={index} className={`message-item ${messageTypeClass}`}>
                            <h3 className="message-title">{item.type}</h3>
                            <p>{item.message}</p>
                            <p>{item.message1}</p>
                            <p>{item.message2}</p>
                            <div className="message-links">
                                {item.messageURL && (
                                    <a
                                        className="message-link"
                                        href={item.url_message}
                                        style={{ marginRight: '10px' }}
                                    >
                                        {item.messageURL0}
                                    </a>
                                )}
                                {item.messageURL1 && (
                                    <a
                                        className="message-link"
                                        href={item.url_message1}
                                        style={{ marginRight: '10px' }}
                                    >
                                        {item.messageURL1}
                                    </a>
                                )}
                                {item.messageURL2 && (
                                    <a
                                    className="message-link"
                                    href={item.url_message2}
                                    style={{ marginRight: '10px' }}
                                >
                                    {item.messageURL2}
                                </a>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LogosAndMessages;
